import type { CardInfo } from '@lub0v/santa-utils';
import { participantStatus } from '@src/pages/BoxPage/participantStatus';

/** Everyone except the organizer, who does not need an invite. */
export function invitableParticipants(cards: CardInfo[]): CardInfo[] {
  return cards.filter((card) => !card.isYou);
}

export function invitedCount(cards: CardInfo[], copiedIds: Set<number>): number {
  return invitableParticipants(cards).filter(
    (card) => participantStatus(card, copiedIds) !== 'not_sent',
  ).length;
}

/** Participants who have already looked at their giftee. */
export function revealedCount(cards: CardInfo[]): number {
  return cards.filter((card) => card.isWardKnown).length;
}
